module.exports = __webpack_public_path__ + "static/truth-d157063037e6307e8e9cc9157bf8f097.jpg";